import {
  combineReducers
} from "redux"
import environment from "./environment"
import location from "./location"
import outlet from "./outlet"
import search from "./search"
import data from "./data"
import mymazda from "./mymazda"


export default combineReducers({
  environment,
  location,
  outlet,
  search,
  data,
  mymazda
})



// WEBPACK FOOTER //
// ./src/store/reducers/index.js